import customerModel from './customerModel';
import authority from './../authorityManage/authority.vue';
import customPage from './customPage.vue';
import { templateConfig } from './request';
export default {
  components: {
    authority,
    customerModel,
    customPage
  },
  data() {
    return {
      activeKey: 1,
      id: this.$route.params.id,
      isCustomPage: false,
      permission: []
    };
  },
  created() {
    if (this.$route.params.id != -1) {
      templateConfig({
        customerId: this.$route.params.id
      }).then(res => {
        this.permission = res.data;
        this.isCustomPage = res.status;
      });
    }
  },
  methods: {
    handleOk(val) {
      if (val) {
        this.id = val.customerId;
      }
      this.activeKey = 2;
    },
    tabChange(val) {
      if (this.$route.params.type == -1 && val == 2) {
        return false;
      }
      this.activeKey = val;
    },
    authorityOk() {
      templateConfig({
        customerId: this.id
      }).then(res => {
        this.isCustomPage = res.status;
        this.permission = res.data;
        if (res.status) {
          this.activeKey = 3;
        } else {
          this.$router.go(-1);
        }
      });
    },
    backFun() {
      this.activeKey = 2;
    }
  }
};